import React from 'react';

import { Typography } from '@material-ui/core';
import styled, { css } from 'styled-components';

export default function SectionHeader({ heading, ...props }) {
  return (
    <HeaderContainer {...props}>
      <Typography color="primary"> {heading} </Typography>
      {props.rightContent}
    </HeaderContainer>
  );
}

export const HeaderContainer = styled.div`
  padding: ${(props) => props.theme.spacing(1.2)}rem ${(props) => props.theme.spacing(2)}rem !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(props) =>
    props.displayBorder
      ? css`
          border-bottom: 1px solid ${(props) => props.theme.palette.divider};
        `
      : css`
          padding-bottom: ${(props) => props.theme.spacing(1.5)}rem !important;
        `};
`;

// export default React.memo(SectionHeader, ({ heading1 }, { heading2 }) => heading1 === heading2);
